import React, { useEffect, useState, useCallback } from "react";
import { Wifi, WifiOff, CloudOff } from "lucide-react";
import { getPendingSales } from "../lib/offlineQueue";
import { useTenant } from "../lib/TenantContext";

export const OfflineBanner: React.FC = () => {
  const { tenantId } = useTenant();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pendingCount, setPendingCount] = useState(0);

  const updatePending = useCallback(async () => {
    if (!tenantId) return;
    const pending = await getPendingSales();
    // Filter by tenant
    setPendingCount(pending.filter((p) => p.tenantId === tenantId).length);
  }, [tenantId]);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      updatePending();
    };
    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Initial check
    updatePending();

    // Poll for pending sales every 10 seconds
    const interval = setInterval(updatePending, 10000);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearInterval(interval);
    };
  }, [updatePending]);

  if (isOnline && pendingCount === 0) {
    return (
      <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-bold">
        <Wifi size={14} />
        <span>Online</span>
      </div>
    );
  }

  if (!isOnline) {
    return (
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-amber-50 border border-amber-200 text-amber-700 text-xs font-bold">
        <WifiOff size={14} />
        <span>Offline — Ventas se guardarán localmente</span>
        {pendingCount > 0 && (
          <span className="ml-1 bg-amber-200 text-amber-800 px-1.5 py-0.5 rounded text-[10px]">
            {pendingCount} pendiente{pendingCount !== 1 ? "s" : ""}
          </span>
        )}
      </div>
    );
  }

  // Online with pending sales
  return (
    <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-700 text-xs font-bold">
      <CloudOff size={14} />
      <span>
        {pendingCount} venta{pendingCount !== 1 ? "s" : ""} guardada
        {pendingCount !== 1 ? "s" : ""} localmente
      </span>
      <span className="font-medium text-blue-600">
        — sincronización segura en actualización
      </span>
    </div>
  );
};

export default OfflineBanner;
